import React, { useCallback, useEffect, useState } from "react";
import { FieldProps } from "react-jsonschema-form";
import { useProperty } from "../../../components/property-provider";
import { useApiClient } from "../../../lib/http";
import MultiCheckboxGroup from "../../witadmin/CRUD/Common/MultiCheckBoxGroup";
import { WitLabel } from "./common";

export default function ExtrasMultiCheckbox({ schema, formData, onChange, idSchema }: FieldProps) {
  const property = useProperty();
  const httpClient = useApiClient();

  const [extras, setExtras] = useState();

  useEffect(() => {
    if (!extras) {
      async function fetchExtras() {
        const response = await httpClient.get<any>(`/v6/api/v1/${property?.ticker}/extra`);
        response.map((extra: any) => (extra.name = extra.ticker));
        setExtras(response);
      }
      fetchExtras();
    }
  });

  const handleOnChange = useCallback(
    ({ value }) => {
      onChange(value);
    },
    [onChange]
  );

  return (
    <div id={idSchema.$id}>
      <WitLabel>{schema?.title}</WitLabel>
      <MultiCheckboxGroup
        className="witadmin-bs3"
        value={formData}
        field={{
          fieldName: `extrasMultiCheckbox`,
          options: extras || [],
        }}
        onChange={handleOnChange}
      />
    </div>
  );
}
